<template>
  <div id="app">
    <MaintenanceScreen v-if="maintenance.aktif" />
    <template v-else>
      <SplashScreen v-if="showSplashScreen" />
      <router-view v-else />
      <AppFooter v-if="!showSplashScreen && !hideFooter" />
      <UpdateBanner v-if="!showSplashScreen" :footer-visible="!hideFooter" />
    </template>
  </div>
</template>

<script>
import AppFooter from "@/components/Footer.vue";
import UpdateBanner from "@/components/UpdateBanner.vue";
import MaintenanceScreen from "@/components/MaintenanceScreen.vue";
import { maintenance } from "@/utils/maintenance";

export default {
  name: "App",
  data() {
    return {
      maintenance,
      showSplashScreen: true,
      hideFooter: false,
    };
  },
  watch: {
    $route(to) {
      this.checkLoginRoute(to);
    },
  },
  mounted() {
    // Layar pembuka hanya menutupi waktu muat halaman pertama, tidak lagi ditahan 3 detik.
    this.$router.isReady().finally(() => {
      this.showSplashScreen = false;
      this.checkLoginRoute(this.$route);
    });
  },
  methods: {
    checkLoginRoute(route) {
      const hiddenFooterRoutes = ["/login", "/register", "/pendaftaran-perawatan-luka-kalus", "/tambah-alamat-user"];

      // Cek route statis
      if (hiddenFooterRoutes.includes(route.path)) {
        this.hideFooter = true;
        return;
      }

      // Cek route dinamis (edit-alamat dengan ID)
      if (route.path.startsWith("/edit-alamat-user/")) {
        this.hideFooter = true;
        return;
      }

      // Public agent self-registration form (/daftar-agent/:referralCode)
      if (route.path.startsWith("/daftar-agent/")) {
        this.hideFooter = true;
        return;
      }

      // Link masuk dari WhatsApp (/masuk, /masuk/:token)
      if (route.name === "masuk-link") {
        this.hideFooter = true;
        return;
      }

      // Default: tampilkan footer
      this.hideFooter = false;
    },
  },
  components: {
    AppFooter,
    UpdateBanner,
    MaintenanceScreen,
  },
};
</script>
